import { MainHeader } from '../components/MainHeader';
import { Footer } from '../components/Footer';
import { InboxList } from '../components/InboxList';
import { RequireCustomer } from '../../lib/use-customer-auth';

export default function InboxPage() {
  return (
    <RequireCustomer>
      <div className="min-h-screen bg-white flex flex-col">
        <MainHeader />
        <main className="flex-1 py-6 md:py-12">
          <InboxList role="customer" />
        </main>
        <Footer />
      </div>
    </RequireCustomer>
  );
}
